<template>
    <div style="width: 800px">
        <el-form :model="update" :rules="rules" ref="edit" label-width="120px" size="small">

            <el-form-item label="请输入旧密码" prop="password">
                <el-input type="password" v-model="update.oldPassword" style="width: 282px"></el-input>
            </el-form-item>
            <el-form-item label="请输入新密码" prop="password">
                <el-input type="password" v-model="update.newPassword" style="width: 282px"></el-input>
            </el-form-item>
            <el-form-item label="请再次输密码" prop="password">
                <el-input type="password" v-model="update.newPassword1" style="width: 282px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="getDate" style="width: 76px">确定</el-button>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                authorization: localStorage.getItem('authorization'),
                update: {
                    oldPassword: "",
                    newPassword: "",
                    newPassword1: "",
                },
                rules: {
                    oldPassword: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
                    newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'}],
                    newPassword1: [{required: true, message: '请再次输入新密码', trigger: 'blur'}],

                }
            }
        },
        mounted() {

        },
        methods: {


            getDate() {
                this.$refs.edit.validate(valid => {
                    let params =new FormData();
                        if (valid) {
                            if(this.update.newPassword==this.update.newPassword1){
                                this.axios.put('/api-u/10024/100048?oldPassword='+ this.update.oldPassword+"&newPassword="+this.update.newPassword,params,{
                                    headers: {
                                        Authorization: this.authorization
                                    }
                                }).then(res => {
                                    if(res.data.code== 10000){
                                        this.$message.success("修改成功请重新登录")
                                        this.$nextTick(() => {
                                            localStorage.clear();
                                            window.sessionStorage.clear();

                                            this.$router.push('/login');
                                        })

                                    }else {
                                        this.$message.error(res.data.message)
                                    }

                                })
                            }
                        }else{
                            this.$message.error('请按照要求正确填写相关信息')
                        }
                    }
                )

            }

        }
    }
</script>

<style scoped>

</style>